import React from "react";
import { NavLink } from "react-router-dom";

function Nav() {
  return (
    <ul className="nav">
      <li className="navItem">
        <NavLink exact activeClassName="activeNav" to="/">
          Releases
        </NavLink>
      </li>
      <li className="navItem">
        <NavLink activeClassName="activeNav" to="/about">
          About
        </NavLink>
      </li>
      <li className="navItem">
        <NavLink activeClassName="activeNav" to="/contact">
          Contact
        </NavLink>
      </li>
    </ul>
  );
}

export default Nav;



// WEBPACK FOOTER //
// ./src/navbar.js